/**
 * Lazy widget façade — no-ops until `loadWidgetUi()` resolves (when widget !== false).
 */

import type { CoignConfig, CoignTheme } from '../types.js';

type WidgetModule = typeof import('../ui/widget.js');

let mod: WidgetModule | null = null;

export async function loadWidgetUi(): Promise<WidgetModule> {
  if (!mod) {
    mod = await import('../ui/widget.js');
  }
  return mod;
}

export function isWidgetLoaded(): boolean {
  return mod !== null;
}

export function createWidget(config: CoignConfig, onSubmit?: (question: string) => void): void {
  mod?.createWidget(config, onSubmit);
}

export function destroyWidget(): void {
  mod?.destroyWidget();
}

export function showWidget(): void {
  mod?.showWidget();
}

export function hideWidget(): void {
  mod?.hideWidget();
}

export function openPanel(): void {
  mod?.openPanel();
}

export function closePanel(): void {
  mod?.closePanel();
}

export function mountInline(selector: string): void {
  mod?.mountInline(selector);
}

export function unmountInline(): void {
  mod?.unmountInline();
}

export function addAssistantMessage(content: string): void {
  mod?.addAssistantMessage(content);
}

export function addToolCallMessage(toolName: string, args?: string): void {
  mod?.addToolCallMessage(toolName, args);
}

export function addToolResultMessage(toolName: string, result?: string): void {
  mod?.addToolResultMessage(toolName, result);
}

export function applyTheme(theme: CoignTheme | undefined): void {
  mod?.applyTheme(theme);
}

export function setThinking(thinking: boolean): void {
  mod?.setThinking(thinking);
}

export function startAssistantStream(): void {
  mod?.startAssistantStream();
}

export function appendStreamToken(token: string): void {
  mod?.appendStreamToken(token);
}

export function finishAssistantStream(): void {
  mod?.finishAssistantStream();
}

export function setStatus(status: 'loading' | 'ready' | 'error'): void {
  mod?.setStatus(status);
}

export function setUpgradeStatus(status: 'quick' | 'full' | 'upgrading' | ''): void {
  mod?.setUpgradeStatus(status);
}

export function setOnOpenCallback(cb: (() => void) | null): void {
  mod?.setOnOpenCallback(cb);
}
